import React from 'react';
import styled from 'styled-components';

import { VenuePreviewCard } from './VenuePreviewCard';

type Venue = {
  name: string;
  description: string;
  imageUrl: string | null;
};

type AdCampaignPreviewProps = {
  venue: Venue;
};

const StyledRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AdCampaignPreview = ({ venue }: AdCampaignPreviewProps) => {
  const { name, description, imageUrl } = venue;

  return <StyledRoot>{<VenuePreviewCard name={name} description={description} imageUrl={imageUrl} />}</StyledRoot>;
};
